<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37.25 37.25" style="width: 100%">
        <g id="Capa_2" data-name="Capa 2">
            <path class="cls-1"
                  d="M37.25,18.63A18.61,18.61,0,0,0,6.57,4.45l-.05-.06L5.46,5.46h0L4.39,6.52l.06.05A18.61,18.61,0,0,0,30.68,32.81l.05,0,2.13-2.13,0-.05A18.55,18.55,0,0,0,37.25,18.63ZM18.63,3A15.62,15.62,0,0,1,30.68,28.56l-22-22A15.59,15.59,0,0,1,18.63,3Zm0,31.25A15.62,15.62,0,0,1,6.57,8.69l22,22A15.56,15.56,0,0,1,18.63,34.25Z"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: "CancelIcon"
}
</script>

<style scoped>
.cls-1 {
    fill: currentColor;
}
</style>
